var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * vbox
 */
import Group from '../../shapes/Group';
import Rect from '../../shapes/Rect';
import { createRef } from '../../utils/ref';
import { getPadding } from '../flexlayout';
import VNode from '../vnode';
import * as lodash from '../../utils/lodash';
import { rect1px } from '../../utils/line1px';
var Box = /** @class */ (function (_super) {
    __extends(Box, _super);
    function Box(props) {
        var _this = _super.call(this, props) || this;
        _this.defaultProps = {
            lineClamp: 1,
            borderRadius: 0,
            borderWidth: 0,
            padding: 0,
            align: 'start',
            pack: 'start',
            flex: 0,
            background: 'rgba(0,0,0,0)',
        };
        _this.props = __assign(__assign({}, _this.defaultProps), props);
        return _this;
    }
    Box.prototype.render = function () {
        var group = new Group(__assign({}, this.getEventsAndCursor()));
        var _a = this.props, borderRadius = _a.borderRadius, borderWidth = _a.borderWidth;
        var isRoot = !this.parentNode;
        if (borderRadius && !borderWidth && isRoot) {
            var clipRef = createRef();
            var rect_1 = new Rect(__assign(__assign({ ref: clipRef }, this.bbox), { r: this.props.borderRadius, fill: 'none', stroke: 'none' }));
            group.setAttr('clip', clipRef);
            group.add(rect_1);
        }
        var attr = __assign(__assign(__assign({}, this.bbox), this.getStyle()), this.props.boxShadow);
        var rect = isRoot ? new Rect(rect1px(attr)) : new Rect(attr);
        group.add(rect);
        this.children.forEach(function (child) { return group.add(child.render()); });
        return group;
    };
    Box.prototype.getContentSize = function () {
        return [0, 0];
    };
    Box.prototype.getContentBox = function () {
        var _a = getPadding(this.props.padding), paddingTop = _a.paddingTop, paddingLeft = _a.paddingLeft, paddingRight = _a.paddingRight, paddingBottom = _a.paddingBottom;
        var borderWidth = this.props.borderWidth;
        return {
            x: this.bbox.x + paddingLeft + borderWidth / 2,
            y: this.bbox.y + paddingTop + borderWidth / 2,
            width: this.bbox.width - paddingLeft - paddingRight - borderWidth,
            height: this.bbox.height - paddingTop - paddingBottom - borderWidth,
        };
    };
    Box.prototype.computeSize = function () {
        var _a = getPadding(this.props.padding), paddingTop = _a.paddingTop, paddingLeft = _a.paddingLeft, paddingRight = _a.paddingRight, paddingBottom = _a.paddingBottom;
        var borderWidth = this.props.borderWidth;
        var _b = this.getContentSize(), contentWidth = _b[0], contentHeight = _b[1];
        var width = lodash.isNumber(this.props.width)
            ? this.props.width
            : contentWidth + paddingLeft + paddingRight;
        var height = lodash.isNumber(this.props.height)
            ? this.props.height
            : contentHeight + paddingTop + paddingBottom;
        width = this.getClampSize(width, 'width');
        height = this.getClampSize(height, 'height');
        this.minSize = [width + borderWidth * 2, height + borderWidth * 2];
    };
    return Box;
}(VNode));
export default Box;
